export const appTranslations = {
  en: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "ng-locale-en" */
      './en.json'
    ).then(translations => ({
      en: translations.default,
    })),
  de: () =>
    import(
      /* webpackChunkName: "ng-locale-de" */
      './de.json'
    ).then(translations => ({ de: translations.default })),
  fr: () =>
    import(
      /* webpackChunkName: "ng-locale-fr" */
      './fr.json'
    ).then(translations => ({ fr: translations.default })),
  nl: () =>
    import(/* webpackChunkName: "ng-locale-nl" */ './nl.json').then(translations => ({
      nl: translations.default,
    })),
  fi: () =>
    import(/* webpackChunkName: "ng-locale-fi" */ './fi.json').then(translations => ({
      fi: translations.default,
    })),
  sv: () =>
    import(/* webpackChunkName: "ng-locale-sv" */ './sv.json').then(translations => ({
      sv: translations.default,
    })),
};

export const wysiwygTranslations = {
  en: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "ng-locale-en" */
      '@core/prosemirror-legacy/locales/src/en.json'
    ).then(t => ({ en: t.default })),
  de: () =>
    import(
      /* webpackChunkName: "ng-locale-de" */
      '@core/prosemirror-legacy/locales/src/de.json'
    ).then(t => ({ de: t.default })),
  fr: () =>
    import(
      /* webpackChunkName: "ng-locale-fr" */
      '@core/prosemirror-legacy/locales/src/fr.json'
    ).then(t => ({ fr: t.default })),
  nl: () =>
    import(
      /* webpackChunkName: "ng-locale-nl" */
      '@core/prosemirror-legacy/locales/src/nl.json'
    ).then(t => ({ nl: t.default })),
  fi: () =>
    import(
      /* webpackChunkName: "ng-locale-fi" */
      '@core/prosemirror-legacy/locales/src/fi.json'
    ).then(t => ({ fi: t.default })),
  sv: () =>
    import(
      /* webpackChunkName: "ng-locale-sv" */
      '@core/prosemirror-legacy/locales/src/sv.json'
    ).then(t => ({ sv: t.default })),
};
